import { useState, useEffect } from 'react'
import { AllStatusWrapper } from '../../../../components/execution/terminal/AllStatusWrapper'
import { PaymentStatus, TerminalStatus, TerminalStatusContext } from '../../../../types/mf-execution.types'
import { useSystematicPaymentStatusQuery } from '../../../../hooks/mf-execution/useSystematicPaymentStatusQuery'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { postCTA } from '../../../../utils/appBridge'
import { getOrdersTabCTA } from '../../../../utils/mutualFundDetail'
import { convertMillisecondsToMinutesAndSeconds } from '../../../../utils/utils'

export const SIPNetBankPaymentStatusPage = () => {
  const [status, setStatus] = useState<TerminalStatus>(TerminalStatus.LOADING)
  const navigate = useNavigate()
  const { paymentStatus, isError, isExpired, timeLeft } = useSystematicPaymentStatusQuery({ maxTimer: 120000 })
  const [searchParams] = useSearchParams()
  const sxpId = searchParams.get('sxpId')

  useEffect(() => {
    if (isError || paymentStatus?.status === PaymentStatus.FAILED) {
      setStatus(TerminalStatus.FAILURE)
    } else if (paymentStatus?.status === PaymentStatus.SUCCESS) {
      setStatus(TerminalStatus.PARTIAL_SUCCESS)
      setTimeout(() => {
        navigate(`/sip/auto-pay/methods?sxpId=${sxpId}`)
      }, 2000)
    }
  }, [paymentStatus, isError])

  useEffect(() => {
    if (isExpired && status === TerminalStatus.LOADING) {
      setStatus(TerminalStatus.PENDING)
    }
  }, [isExpired, status])

  return (
    <div className='w-full h-screen relative overflow-hidden'>
      <AllStatusWrapper
        status={status}
        statusContext={TerminalStatusContext.SIP}
        loadingConfig={{
          title: 'Confirming your <br /> payment',
          caption: `This screen will timeout in ${convertMillisecondsToMinutesAndSeconds(timeLeft)} <br />  Do not press back or close this screen.`
        }}
        partialSuccessConfig={{
          title: 'Payment Completed'
        }}
        failureConfig={{
          title: 'Payment failed',
          caption: 'Any amount deducted will be credited to <br /> source within 2-4 working days.',
          ctas: [
            {
              ctaType: 'primary',
              label: 'Go to dashboard',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
        pendingConfig={{
          title: 'Payment pending',
          caption: 'It’s taking longer than expected. We’ll <br /> notify you once your payment is confirmed.',
          ctas: [
            {
              ctaType: 'primary',
              label: 'Close',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
      />
    </div>
  )
}
